import { render, staticRenderFns } from "./Goodpush.vue?vue&type=template&id=7e66bb4e&scoped=true"
import script from "./Goodpush.vue?vue&type=script&lang=js"
export * from "./Goodpush.vue?vue&type=script&lang=js"
import style0 from "./Goodpush.vue?vue&type=style&index=0&id=7e66bb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66bb4e",
  null
  
)

export default component.exports